import { useEffect, useRef } from "react";
import { api } from "@/lib/api";

const audioCache = new Map();
let voiceDown = false;
let current = null;

export const voiceAvailable = () => !voiceDown;

// Read aloud via the server (ElevenLabs, cached by text). On failure the voice turns off quietly for this session.
export async function speak(hubId, text, muted) {
  if (muted || voiceDown || !text) return false;
  try {
    let url = audioCache.get(text);
    if (!url) {
      const { data } = await api.get(`/organizations/${hubId}/learn/tts`, { params: { text }, responseType: "blob", timeout: 35000 });
      url = URL.createObjectURL(data);
      audioCache.set(text, url);
    }
    current?.pause();
    current = new Audio(url);
    await current.play().catch(() => {});
    return true;
  } catch (_) {
    voiceDown = true;
    return false;
  }
}

export const stopSpeaking = () => current?.pause();

let ac = null;
export function blip(kind, muted) {
  if (muted) return;
  try {
    ac = ac || new (window.AudioContext || window.webkitAudioContext)();
    const notes = kind === "right" ? [660, 880] : kind === "star" ? [523, 659, 784, 1047] : [300, 220];
    notes.forEach((f, i) => {
      const o = ac.createOscillator();
      const g = ac.createGain();
      const t = ac.currentTime + i * 0.12;
      o.type = kind === "wrong" ? "triangle" : "sine";
      o.frequency.value = f;
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(0.18, t + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, t + 0.3);
      o.connect(g).connect(ac.destination);
      o.start(t);
      o.stop(t + 0.35);
    });
  } catch (_) { /* audio blocked */ }
}

// Sends a heartbeat every 15 s while the kid has touched/typed in the last 60 s (idle time stops counting).
export function useHeartbeat(hubId, active, onLocked) {
  const last = useRef(Date.now());
  useEffect(() => {
    if (!active) return undefined;
    const poke = () => { last.current = Date.now(); };
    ["pointerdown", "keydown"].forEach((e) => window.addEventListener(e, poke));
    const id = setInterval(async () => {
      if (Date.now() - last.current > 60000) return;
      try { const { data } = await api.post(`/organizations/${hubId}/learn/heartbeat`); if (data.locked) onLocked(); } catch (_) { /* offline: try next beat */ }
    }, 15000);
    return () => { clearInterval(id); ["pointerdown", "keydown"].forEach((e) => window.removeEventListener(e, poke)); };
  }, [hubId, active, onLocked]);
}
